<template>
  <div>
    <md-snackbar :md-active.sync="snackbar.show" :md-duration="8000">
      <span>
        <template>
          <md-icon class="md-primary">{{ snackbar.icon }}</md-icon>
          &nbsp;&nbsp;&nbsp;
        </template>
        {{ snackbar.content }}
      </span>
      <md-button
        class="md-primary md-simple md-dense"
        @click="snackbar.show = false"
      >
        Dismiss
      </md-button>
    </md-snackbar>
    <group-card title="Referrals" icon="connect_without_contact" padded>
      <template slot="actions">
        <loading-icon-button
          @click="getIntroducers"
          tooltip="Refresh"
          :loading="progress_indicator.introducer_list"
        >
          cached
        </loading-icon-button>
      </template>
      <div data-app>
        <v-text-field
          v-model="search"
          append-icon="search"
          label="Search"
          single-line
          hide-details
        ></v-text-field>
        <v-data-table
          :headers="introducerHeader"
          :items="introducersData"
          :search="search"
          item-key="name"
          :items-per-page="10"
          class="elevation-0 introducer_table"
          :footer-props="{
            showFirstLastPage: true,
            firstIcon: 'first_page',
            lastIcon: 'last_page',
            prevIcon: 'skip_previous',
            nextIcon: 'skip_next'}"
          :loading="progress_indicator.introducer_list"
          :item-class="row_class"
          loading-text="Loading... Please wait"
        >
          <template v-slot:item.actions="{ item }">
            <loading-icon-button
              @click="sendRequest(item)"
              tooltip="Send Request"
            >
             mail
            </loading-icon-button>
          </template>

          <template v-slot:item.trigger_1="{ item }">
            <div>
              <span class="trigger">{{ item.trigger_1 }}</span>
              <p class="rate" v-if="item.trigger_type == 'percentage'">{{ item.rate_1 | suffix('%') }}</p>
              <p class="rate" v-else>{{ item.rate_1 | currency }}</p>
            </div>
          </template>
        </v-data-table>
      </div>
    </group-card>
    <!-- Request Changes Dialog Start -->
    <ValidationObserver v-slot="{ invalid }">
      <md-dialog :md-active.sync="show.request_send_dialog">
        <md-dialog-title>Send Request</md-dialog-title>
        <div v-if="errorMessage">
          <p class="errorMsg">{{ errorMessage }}</p>
        </div>
        <p class="infoMsg">Please select the fields which you want to update</p>
          <div class="md-layout">
              <md-checkbox class="md-layout-item md-size-30" v-model="requestFields.email.requested">
              Email
              </md-checkbox>
              <validated-text-input
                            label="Email"
                            class="md-layout-item md-size-55 field"
                            ref="email_input"
                            v-model="requestFields.email.new_value"
                            melissaCheckType="email"
                            :regex="emailRegex"
                            :disabled="!requestFields.email.requested"
                            @is-melissa-check-passed-changed="updateMelissaCheck"
                />
          </div>
          <div class="md-layout">
              <md-checkbox class="md-layout-item md-size-30" v-model="requestFields.phone.requested">
              Phone
              </md-checkbox>
              <validated-text-input
                            label="Phone"
                            class="md-layout-item md-size-55 field"
                            ref="phone_input"
                            v-model="requestFields.phone.new_value"
                            :minLength="10"
                            :maxLength="12"
                            errormsg="Please enter a valid phone number, format must be a valid Australian number and only include numbers or +"
                            melissaCheckType="phone"
                            :disabled="!requestFields.phone.requested"
                            @is-melissa-check-passed-changed="updateMelissaCheck"
                />
          </div>
          <div class="md-layout">
              <md-checkbox class="md-layout-item md-size-30" v-model="requestFields.address.requested">
              Address
              </md-checkbox>
              <validated-input label="Address"
                            ref="address_input"
                            class="md-layout-item md-size-55 field"
                            type="REQUIRED_STRING"
                            :disabled="!requestFields.address.requested"
                            v-model="requestFields.address.new_value" />
          </div>
          <div class="md-layout">
              <md-checkbox class="md-layout-item md-size-30" v-model="requestFields.contact_name.requested">
                  Contact name
              </md-checkbox>
              <validated-input label="Contact Name"
                            ref="contact_name_input"
                            class="md-layout-item md-size-55 field"
                            type="REQUIRED_STRING"
                            :disabled="!requestFields.contact_name.requested"
                            v-model="requestFields.contact_name.new_value" />
          </div>
        <md-dialog-actions>
          <md-button class="md-primary md-simple" @click="onRequestSendCancel">Cancel</md-button>
          <md-button class="md-primary md-simple"
            @click="onRequestSendSave"
            :disabled="sendDisabled || invalid"
          >
            Send Request
          </md-button>
        </md-dialog-actions>
      </md-dialog>
    </ValidationObserver>
    <!-- Request Changes Dialog End -->
  </div>
</template>
<script>
import { GroupCard } from "@/components";
import { mapGetters } from "vuex";
import ValidatedInputs from '@/components/ValidatedInput';
import LoadingIconButton from '@/components/LoadingIconButton';

export default {
  components: {
    GroupCard,
    LoadingIconButton,
    ...ValidatedInputs
  },
  data() {
    return {
      isMelissaCheckPassed: false,
      isUpdating: false,
      introducersData: [],
      isBroker: true,
      errorMessage : null,
      snackbar: {
        show: false,
        icon: "done",
        content: "Request sent successfully",
      },
      search: '',
      progress_indicator: {
        introducer_list: false,
      },
      requestFields: {
        id : false,
        email : {'requested': false, 'new_value': ''},
        phone : {'requested': false, 'new_value': ''},
        address : {'requested': false, 'new_value': ''},
        contact_name : {'requested': false, 'new_value': ''},
      },
      introducerHeader: [
        {text: 'ID', value: "id"},
        {text: 'Trading Name', value: 'trading_name'},
        {text: 'Full Name', value: 'full_name'},
        {text: 'Phone', value: 'contact_number'},
        {text: 'Email', value: 'email'},
        {text: 'State', value: 'state'},
        {text: 'Postcode', value: 'post_code'},
        {text: 'Leads', value: 'leads'},
        {text: 'Recent Leads', value: 'recent_leads'},
        {text: 'Supplier', value: 'supplier'},
        {text: 'Recent Supplier', value: 'recent_supplier'},
        {text: 'Asset Type', value: 'referral_asset_type'},
        {text: 'Associated Broker', value: 'bdm_broker'},
        {text: 'Active via carsale', value: 'referral_cs_dealer_id'},
        {text: 'Opted in via carsales', value: 'referral_opted_cs'},
        {text: 'New Lead Notification', value: 'referral_new_lead_notification'},
        {text: 'Ausloans referral agreement', value: 'referral_agreement'},
        {text: 'Actions', value: 'actions', sortable: false},
      ],
      show: {
        request_send_dialog: false
      },
    }
  },
  methods: {
    async getIntroducers() {
      try {
        this.progress_indicator.introducer_list = true
        await this.$store.dispatch('fetch_referrals');
        this.introducersData = this.introducers;
      } catch (err) {
        console.log(err);
      } finally {
        this.progress_indicator.introducer_list = false
      }
    },
    onRequestSendCancel() {
        this.errorMessage = '';
        this.show.request_send_dialog = false;
    },
    sendRequest(item) {
        this.errorMessage = '';
        this.requestFields.id = item.id
        this.show.request_send_dialog = true;
    },
    updateMelissaCheck(isMelissaCheckVal) {
        this.isMelissaCheckPassed = isMelissaCheckVal;
    },
    onRequestSendSave() {
      this.isUpdating = true;
      axios.post("/api/v1/introducers/send_mail", this.requestFields
      ).then((res) => {
        this.requestFields = {
          id : false,
          email : {'requested': false, 'new_value': ''},
          phone : {'requested': false, 'new_value': ''},
          address : {'requested': false, 'new_value': ''},
          contact_name : {'requested': false, 'new_value': ''},
        };
        this.errorMessage = '';
        this.show.request_send_dialog = false;
        this.snackbar.show = true;
        this.isUpdating = false;
      }).catch((err) => {
        this.errorMessage = err.response.data;
        this.isUpdating = false;
      });
    },
    row_class(item) {
      if (item.referral_agreement === 'Yes') {
        return "bg-green-light";
      }
    },
  },
  created() {
    this.getIntroducers()
  },
  computed: {
    ...mapGetters(["introducers"]),
    sendDisabled() {
        // disable the send button if no fields are requested OR fields are requested but empty OR if already sending req
        return (
            !this.requestFields.email.requested && !this.requestFields.phone.requested
            && !this.requestFields.address.requested && !this.requestFields.contact_name.requested)
            ||((!this.requestFields.email.new_value && this.requestFields.email.requested)
            || (!this.requestFields.phone.new_value && this.requestFields.phone.requested)
            || (!this.requestFields.address.new_value && this.requestFields.address.requested)
            || (!this.requestFields.contact_name.new_value && this.requestFields.contact_name.requested))
            || this.isUpdating
            || !this.isMelissaCheckPassed;
    }
  },
  created() {
    this.getIntroducers()
  }
}

</script>
<style lang="scss" scoped>
@import "@/assets/scss/theme.scss";
.introducer_table {
  table {
    td {
      text-align: center;
    }
  }

  .v-data-footer__select {
    display: none;
  }
}
.introducer_table::v-deep .bg-green-light {
  background-color: $ausloans-green-light;
}
.rate{
  font-weight: bold;
}
.trigger{
  color:dimgrey;
  font-size: 10px;
}
.errorMsg, .infoMsg {
  padding: 0px 20px;
}
.field {
    margin-right: 20px;
}

</style>

